import React, { FC } from 'react';
import { Tab, useTranslate, usePermissions } from 'react-admin';
import Avatar from '@material-ui/core/Avatar';
import SvgIcon from '@material-ui/core/SvgIcon';

import { Show, PaperTabbedShowLayout } from '~/layout';
import { l } from './BankAccountList';
import { AlbumsIcon as BankAccountIcon } from '~/img';
import Details from './components/Details';
import TransfersHistory from './components/TransfersHistory';
import BankDaySummary from './components/BankDaySummary';
import { NoPermissions } from '~/components/ra';

const BankAccountShow: FC<any> = (props) => {
  const { permissions } = usePermissions();

  const translate = useTranslate();
  const t = (key: string): string => translate(l(key));

  if (!permissions) return null;
  if (!permissions?.includes('bank.account.view')) return <NoPermissions />;

  return (
    <Show
      icon={
        <Avatar>
          <SvgIcon>
            <BankAccountIcon />
          </SvgIcon>
        </Avatar>
      }
      {...props}
    >
      <PaperTabbedShowLayout>
        <Tab label={t('tabs.details')}>
          <Details permissions={permissions} />
        </Tab>
        {permissions?.includes('bank.account.daySummary.list') && (
          <Tab label={t('tabs.bankDaySummary')} path='bankDaySummary'>
            <BankDaySummary permissions={permissions} />
          </Tab>
        )}
        {permissions?.includes('bank.account.transfer.list') && (
          <Tab label={t('tabs.transfers')} path='transfers'>
            <TransfersHistory permissions={permissions} />
          </Tab>
        )}
      </PaperTabbedShowLayout>
    </Show>
  );
};

export default BankAccountShow;
